import { createActions } from 'reduxsauce';

var _createActions = createActions({
  request: function request() {
    return {
      type: 'CART_REQUEST'
    };
  },
  post: function post() {
    return {
      type: 'CART_POST'
    };
  },
  postItem: function postItem() {
    return {
      type: 'CART_POST_ITEM'
    };
  },
  postItemReceive: function postItemReceive(json) {
    return {
      type: 'CART_POST_ITEM_RECEIVE',
      newItem: json.newItem,
      foodBasketId: json.foodBasketId,
      cateringBasketId: json.cateringBasketId,
      upsellInfo: json.upsellInfo
    };
  },
  patchItem: function patchItem() {
    return {
      type: 'CART_PATCH_ITEM'
    };
  },
  closeAddTo: function closeAddTo() {
    return {
      type: 'CART_CLOSE_ADD_TO'
    };
  },
  delete: function _delete() {
    return {
      type: 'CART_DELETE'
    };
  },
  response: function response(json) {
    return {
      type: 'CART_RESPONSE',
      cart: json.cart,
      price: json.price,
      isCatering: json.isCatering,
      isFood: json.isFood,
      isRetail: json.isRetail,
      destructuredCart: json.destructuredCart,
      food: json.food,
      cater: json.cater,
      displayErrors: json.displayErrors,
      isTokenExEnabled: json === null || json === void 0 ? void 0 : json.isTokenExEnabled,
      GiftCardDetails: json === null || json === void 0 ? void 0 : json.GiftCardDetails
    };
  },
  tokenExGetAuthKey: function tokenExGetAuthKey(json) {
    return {
      type: 'CART_TOKEN_EX_GET_AUTH_KEY',
      error: json.Error,
      authenticationKey: json.AuthenticationKey,
      tokenScheme: json.TokenScheme,
      timestamp: json.Timestamp,
      origin: json.Origin
    };
  },
  requestDeliveryMode: function requestDeliveryMode() {
    return {
      type: 'CART_REQUEST_DELIVERY_MODE'
    };
  },
  recieveDeliveryMode: function recieveDeliveryMode(json) {
    return {
      type: 'CART_RECIEVE_DELIVERY_MODE'
    };
  },
  requestTimeWanted: function requestTimeWanted() {
    return {
      type: 'CART_REQUEST_TIME_WANTED'
    };
  },
  recieveTimeWanted: function recieveTimeWanted(json) {
    return {
      type: 'CART_RECIEVE_TIME_WANTED',
      timeWanted: json.timeWanted
    };
  },
  requestDeliveryInfo: function requestDeliveryInfo(json) {
    return {
      type: 'CART_REQUEST_DELIVERY_INFO'
    };
  },
  requestDeliveryInfoFail: function requestDeliveryInfoFail() {
    return {
      type: 'CART_REQUEST_DELIVERY_INFO_FAIL'
    };
  },
  recieveDeliveryInfo: function recieveDeliveryInfo(json) {
    return {
      type: 'CART_RECIEVE_DELIVERY_INFO',
      deliveryInfo: json.deliveryInfo
    };
  },
  requestSubmitCart: function requestSubmitCart() {
    return {
      type: 'CART_REQUEST_SUBMIT_CART'
    };
  },
  recieveSubmitCart: function recieveSubmitCart(json) {
    return {
      type: 'CART_RECIEVE_SUBMIT_CART',
      submitInfo: json.submitInfo,
      paymentInfo: json.paymentInfo
    };
  },
  closeCheckout: function closeCheckout() {
    return {
      type: 'CART_CLOSE_CHECKOUT'
    };
  },
  setGoToCheckout: function setGoToCheckout(json) {
    return {
      type: 'CART_SET_GO_TO_CHECKOUT',
      goToCheckout: json.goToCheckout
    };
  },
  requestPostTip: function requestPostTip() {
    return {
      type: 'CART_REQUEST_POST_TIP'
    };
  },
  recievePostTip: function recievePostTip() {
    return {
      type: 'CART_RECIEVE_POST_TIP'
    };
  },
  requestDeliveryModeOptions: function requestDeliveryModeOptions() {
    return {
      type: 'CART_REQUEST_DELIVERY_MODE_OPTION'
    };
  },
  recieveDeliveryModeOptions: function recieveDeliveryModeOptions(json) {
    return {
      type: 'CART_RECIEVE_DELIVERY_MODE_OPTIONS',
      deliveryModes: json.deliveryModes
    };
  },
  saveForEdit: function saveForEdit(json) {
    return {
      type: 'CART_SAVE_FOR_EDIT',
      saveForEdit: json.saveForEdit
    };
  },
  resetSaveForEdit: function resetSaveForEdit() {
    return {
      type: 'CART_RESET_SAVE_FOR_EDIT'
    };
  },
  requestCurbside: function requestCurbside() {
    return {
      type: 'CART_REQUEST_CURBSIDE'
    };
  },
  recieveCurbside: function recieveCurbside() {
    return {
      type: 'CART_RECIEVE_CURBSIDE'
    };
  },
  requestPromoCode: function requestPromoCode() {
    return {
      type: 'CART_REQUEST_PROMO_CODE'
    };
  },
  recievePromoCode: function recievePromoCode(code) {
    return {
      type: 'CART_RECIEVE_PROMO_CODE',
      newCode: code
    };
  },
  removePromoCode: function removePromoCode(code) {
    return {
      type: 'CART_REMOVE_PROMO_CODE',
      removeCode: code
    };
  },
  setDeliveryMode: function setDeliveryMode(json) {
    return {
      type: 'CART_SET_DELIVERY_MODE',
      deliveryMode: json.deliveryMode
    };
  },
  setShippingMode: function setShippingMode(shippingMode) {
    return {
      type: 'CART_SET_SHIPPING_MODE',
      shippingMode: shippingMode
    };
  },
  requestValidateCart: function requestValidateCart() {
    return {
      type: 'CART_REQUEST_VALIDATE_CART'
    };
  },
  recieveValidateCart: function recieveValidateCart() {
    return {
      type: 'CART_RECIEVE_VALIDATE_CART'
    };
  },
  hideValidateCart: function hideValidateCart() {
    return {
      type: 'CART_HIDE_VALIDATE_CART'
    };
  },
  requestClearCart: function requestClearCart() {
    return {
      type: 'CART_REQUEST_CLEAR_CART'
    };
  },
  recieveClearCart: function recieveClearCart() {
    return {
      type: 'CART_RECIEVE_CLEAR_CART'
    };
  },
  requestGiftCard: function requestGiftCard() {
    return {
      type: 'CART_REQUEST_GIFT_CARD'
    };
  },
  recieveGiftCard: function recieveGiftCard(json) {
    return {
      type: 'CART_RECIEVE_GIFT_CARD',
      giftCardInfo: json.giftCardInfo,
      price: json.price
    };
  },
  requestGiftCardScheme: function requestGiftCardScheme() {
    return {
      type: 'CART_REQUEST_GIFT_CARD_SCHEME'
    };
  },
  recieveGiftCardScheme: function recieveGiftCardScheme(json) {
    return {
      type: 'CART_RECIEVE_GIFT_CARD_SCHEME',
      giftCardScheme: json.giftCardScheme,
      ccScheme: json.ccScheme
    };
  },
  requestShippingModes: function requestShippingModes() {
    return {
      type: 'CART_REQUEST_SHIPPING_MODES'
    };
  },
  recieveShippingModes: function recieveShippingModes(json) {
    return {
      type: 'CART_RECIEVE_SHIPPING_MODES',
      shippingModes: json.data.shippingMethods
    };
  },
  clearStates: function clearStates() {
    return {
      type: 'CART_CLEAR_STATES'
    };
  },
  recieveSavedCards: function recieveSavedCards(json) {
    return {
      type: 'CART_RECIEVE_SAVED_CARDS',
      savedCards: json.savedCards
    };
  },
  requestPaypalOrder: function requestPaypalOrder(json) {
    return {
      type: 'CART_REQUEST_PAYPAL_ORDER'
    };
  },
  setPaypalOrder: function setPaypalOrder(json) {
    return {
      type: 'CART_SET_PAYPAL_ORDER',
      paypal: json
    };
  },
  resetPaypalOrder: function resetPaypalOrder(json) {
    return {
      type: 'CART_RESET_PAYPAL_ORDER'
    };
  },
  resetLoading: function resetLoading() {
    return {
      type: 'CART_RESET_LOADING'
    };
  },
  setIsLoading: function setIsLoading(obj) {
    return {
      type: 'CART_SET_IS_LOADING',
      isLoading: obj.isLoading
    };
  },
  newsLetterRequest: function newsLetterRequest() {
    return {
      type: 'CART_NEWS_LETTER_REQUEST'
    };
  },
  newsLetterResponse: function newsLetterResponse(json) {
    return {
      type: 'CARTNEWS_LETTER_RESPONSE',
      results: json,
      receivedAt: Date.now()
    };
  },
  reciveLeadtimeErr: function reciveLeadtimeErr(err) {
    return {
      type: 'CART_RECIVE_LEADTIME_ERR',
      leadtimeErr: err
    };
  },
  setPostLoyaltyData: function setPostLoyaltyData(json) {
    return {
      type: 'CART_SET_LOYALTY_DATA',
      loyaltyData: json
    };
  },
  redeemRewardsAction: function redeemRewardsAction(cart, rewardsApplied) {
    return {
      type: 'CART_REDEEM_REWARDS_ACTION',
      cart: cart,
      rewardsApplied: rewardsApplied
    };
  },
  resetRewardsCartAction: function resetRewardsCartAction() {
    return {
      type: 'CART_RESET_REWARDS_CART_ACTION'
    };
  }
}, {
  prefix: 'CART_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};